<template>
  <v-card width="300" max-height="500" dark color="primary">
    <v-card-title>
      <v-row justify="center" align="center">
        <v-col cols="3">
          <avatarStat :traitType="workingTrait.type" @updateType="updateType" edit />
        </v-col>
        <v-col cols="9">
          <v-text-field v-model="workingTrait.name" hide-details />
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row justify="center" align="center">
        <h2>Requirements</h2>
        <v-btn x-small icon @click="workingTrait.requirements.push('')">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-row>
      <div style="max-height:175px; overflow-y: auto; overflow-x: hidden;">
        <v-row
          v-for="(requirement, index) in workingTrait.requirements"
          justify="center"
          align="center"
          :key="index"
          no-gutters>
          <v-col>
            <v-text-field v-model="workingTrait.requirements[index]" hide-details />
          </v-col>
          <v-col cols="1">
            <v-btn x-small icon @click="workingTrait.requirements.splice(index, 1)">
              <v-icon>mdi-minus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <br />
      <v-row>
        <v-textarea
          v-model="workingTrait.description"
          height="140"
          label="Description"
          no-resize
          hide-details />
      </v-row>
    </v-card-text>
    <v-card-actions v-if="!newTrait">
      <!-- Delete the trait -->
      <v-btn icon color="red" @click="deleteTrait()">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
      <!-- Don't save this trait, but create a copy that's the same -->
      <v-btn icon color="blue" @click="copyTrait()">
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
      <v-spacer />
      <!-- Undo changes to the trait -->
      <v-btn color="orange" icon @click="resetTrait()">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <!-- Delete and re-add trait - 'Saving' it -->
      <v-btn icon color="green" @click="updateTrait()">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
    </v-card-actions>
    <v-card-actions v-else>
      <v-spacer />
      <v-btn icon color="green" @click="copyTrait()">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import _ from 'lodash';

export default {
  components: {
    avatarStat: () => import('./avatarStat')
  },
  props: {
    trait: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      workingTrait: { description: '', requirements: [], type: '', name: 'test' },
      newTrait: false
    };
  },
  created() {
    if (this.trait.hasOwnProperty('new')) {
      this.updateType(this.trait.type);
      this.newTrait = true;
    } else {
      this.workingTrait = _.cloneDeep(this.trait);
    }
  },
  methods: {
    ...mapActions('newACTSTraits', [
      'saveTrait',
      'removeTrait',
      'addTrait',
      'getTraits'
    ]),
    resetTrait() {
      this.workingTrait = _.cloneDeep(this.trait);
    },
    updateTrait() {
      this.saveTrait({
        oldName: this.trait.name,
        newTrait: this.workingTrait
      });
      this.resetTrait();
      this.$emit('close');
    },
    deleteTrait() {
      this.removeTrait(this.trait.name);
      this.$emit('close');
    },
    copyTrait() {
      if (this.trait.name === this.workingTrait.name) {
        this.workingTrait.name = 'Copy of ' + this.trait.name;
      }
      this.addTrait(this.workingTrait);
      this.$emit('close');
    },
    updateType(newType) {
      this.$set(this.workingTrait, 'type', newType);
    }
  }
};
</script>

<style></style>
